import React from 'react'
import _ from 'lodash'
import { Icon, Label, Menu, Input } from 'semantic-ui-react'

export default class SelectDriverField extends React.PureComponent {
  state = { searchValue: '' }

  renderDriverSegments = () => {
    const { driverSegments } = this.props
    const { searchValue } = this.state

    const foundDriverSegments = _.filter(driverSegments, driverSegment => {
      const searchNameValue = driverSegment.name

      return (
        searchNameValue.toLowerCase().search(searchValue) !== -1
      )
    })

    return _.map(foundDriverSegments, driverSegment => {
      return this.renderRow(driverSegment)
    })
  }

  renderRow = driverSegment => {
    const { selectedDriverSegment, onSelectDriverSegment, drivers } = this.props

    return (
      <Menu.Item
        key={driverSegment.id}
        active={_.includes(selectedDriverSegment, driverSegment.id)}
        onClick={() => onSelectDriverSegment(driverSegment.id)}
        style={{ padding: '13px 10px', borderRadius: 0 }}
      >
        <div
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            display: 'flex',
          }}
        >
          <Label
            size="large"
            style={{
              marginRight: 5,
              width: 120,
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            {`${driverSegment.name} (${_.filter(drivers, ['driver_segment', driverSegment.id]).length})`}
          </Label>
          {_.includes(selectedDriverSegment, driverSegment.id) && (
            <div
              style={{
                display: 'flex',
                width: 20,
                justifyContent: 'flex-end',
                marginLeft: 5,
              }}
            >
              <Icon name="check" color="green" />
            </div>
          )}
        </div>
      </Menu.Item>
    )
  }

  render() {
    return (
      <Menu vertical style={{ maxHeight: 400, overflow: 'auto', width: 500 }}>
        <Menu.Item key="header" header style={{ padding: 10 }}>
          <div
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              display: 'flex',
            }}
          >
            <div style={{ display: 'flex', flex: 1 }}>List of Driver Segments</div>
            <div style={{ display: 'flex' }}>
              <Input
                type="text"
                placeholder="Search"
                name="search-driver"
                onChange={e =>
                  this.setState({
                    searchValue: e.target.value.toLowerCase().trim(),
                  })
                }
                icon="search"
                style={{ height: 30, width: 200 }}
              />
            </div>
          </div>
        </Menu.Item>
        {this.renderDriverSegments()}
      </Menu>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/fields/selectDriverSegment.js